<template>
  <div class="churn-form-component">
    <form @submit.prevent="onSubmit">
      <div v-for="section in sections" :key="section.name" class="section my-3">
        <h3 class="subheading mt-2">
          {{ section.title }}
        </h3>
        <div>
          <VRating ref="ratings" v-model="section.value" hover />
          <div class="rating-reason">
            {{ activeReason(section) }}
          </div>
        </div>
      </div>
      Do you have a specific example that comes in your mind? Something that can help up improve?
      <VTextField
        v-model="reasonText"
        class="my-3 small base reason-text"
        label="Comment, suggestion…"
        small
        solo
      />
      <VBtn type="submit" :disabled="!isComplete" class="button-next" color="primary">
        Next
      </VBtn>
    </form>
  </div>
</template>

<script>
export default {
  name: 'ChurnForm',

  data() {
    return {
      reasonText: '',
      sections: [
        {
          name: 'reliabilityScore',
          title: 'Reliability',
          reasons: [
            'Almost any feature I tried failed',
            'Most features do not work',
            'Some features do not work',
            'Everything works fine, but some features sometimes failed',
            'Everything works fine',
          ],
          value: -1,
          hoverIndex: -1,
        },
        {
          name: 'valueAddedScore',
          title: 'Added Value',
          reasons: [
            'I did not use the product, no features could help me to solve my problems',
            'Some features are helpful but I did not need most of them',
            'Most features are helpful and I used them on a low to regular basis',
            'Most features are helpful and I used them on a regular to frequent basis',
            'I could not have managed my apps without using actively all the features!',
          ],
          value: -1,
          hoverIndex: -1,
        },
        {
          name: 'assistanceScore',
          title: 'Assistance',
          reasons: [
            'The product onboarding (docs, interface) and the support were terrible',
            'Either product onboarding (docs, interface) or support was terrible',
            'Both product onboarding (docs, interface) and support were fine',
            'Product onboarding (docs, interface) was good but support was not good',
            'Product onboarding (docs, interface) and support were both good !',
          ],
          value: -1,
          hoverIndex: -1,
        },
      ],
    }
  },

  computed: {
    isComplete() {
      return this.sections.every(section => section.value > 0)
    },
  },

  mounted() {
    this.$watch(
      () => this.$refs.ratings.map(r => r.hoverIndex),
      indexes => {
        this.sections.forEach((section, index) => {
          section.hoverIndex = indexes[index]
        })
      },
    )
  },

  methods: {
    activeReason(section) {
      return section.reasons[section.hoverIndex - 1] || section.reasons[section.value - 1]
    },

    onSubmit() {
      const user = this.$store.state.user
      const bucketState = this.$store.getters.currentBucket
      const currentPlan = this.$store.getters.currentPlan
      const getScore = name => this.sections.find(s => s.name === name).value
      this.$emit('submit', {
        email: user.email,
        plan: currentPlan.name,
        createdAt: bucketState.bucket.created_at,
        churnDate: new Date().toISOString(),
        lifeTimeSpent: '0',
        assistanceScore: getScore('assistanceScore'),
        reliabilityScore: getScore('reliabilityScore'),
        valueAddedScore: getScore('valueAddedScore'),
        reasonText: this.reasonText,
        BO: this.$store.getters.backofficeURLs.bucket,
      })
    },
  },
}
</script>

<style lang="postcss" scoped>
.button-next {
  display: block;
  margin-left: auto;
}

.section {
  display: flex;

  & h3 {
    width: 140px;
    flex-shrink: 0;
  }

  & .rating-reason {
    min-height: 1.5em;
  }
}
</style>
